import React from 'react';
import { ButtonLink, StyledButton, StyledAnchor } from './PlayButton.styles';
import PropTypes from 'prop-types';

export const BUTTON_THEME = {
    DEFAULT: 'DEFAULT',
    LIGHT: 'LIGHT',
    WHITE: 'WHITE',
    DARK: 'DARK',
};

export const BUTTON_TYPE = {
    LINK: 'LINK',
    ANCHOR: 'ANCHOR',
    BUTTON: 'BUTTON',
};

export const BUTTON_SIZE = {
    DEFAULT: 'DEFAULT',
    SMALL: 'SMALL',
};

const PlayButton = (props) => {
    if (props.buttonType === BUTTON_TYPE.BUTTON) {
        return <StyledButton {...props} />;
    }

    if (props.buttonType === BUTTON_TYPE.ANCHOR) {
        return <StyledAnchor {...props} />;
    }

    return <ButtonLink {...props} />;
};

PlayButton.propTypes = {
    className: PropTypes.string,
    size: PropTypes.oneOf([BUTTON_SIZE.DEFAULT, BUTTON_SIZE.SMALL]),
    theme: PropTypes.oneOf([BUTTON_THEME.DEFAULT, BUTTON_THEME.LIGHT, BUTTON_THEME.WHITE, BUTTON_THEME.DARK]),
    buttonType: PropTypes.oneOf([BUTTON_TYPE.LINK, BUTTON_TYPE.BUTTON, BUTTON_TYPE.ANCHOR]),
    isDisabled: PropTypes.bool,
    isCentered: PropTypes.bool,
    to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    query: PropTypes.object,
    hash: PropTypes.string,
    state: PropTypes.object,
    activeClassName: PropTypes.string,
    activeStyle: PropTypes.string,
    children: PropTypes.node,
    isExternal: PropTypes.bool,
    isIndexLink: PropTypes.bool,
    scrollToTop: PropTypes.bool,
    onClick: PropTypes.func,
    onAfterClick: PropTypes.func,
    regTestSpec: PropTypes.string,
};

export default PlayButton;
